export default __webpack_public_path__ + "static/media/grid.8ae49d5d.svg";